const config = {
  baseUrl: process.env.REACT_APP_BASE_URL || 'https://flock.video',
  serverUrl: process.env.REACT_APP_SERVER_URL || 'https://api.flock.video',
  youtubeSearchApiEndpoint: process.env.REACT_APP_YOUTUBE_SEARCH_API_URL || 'https://search.flock.video',
  stompEndpoint: '/flock',
};

export default config;
